import { Box, Tooltip, Typography } from "@mui/material";

interface Props {
  quote: CondensedQuote;
}

export function QuotePreviewShipmentIDText(props: Props) {
  const { quote } = props;
  const shipmentId = quote?.shipment || "";
  return (
    <Box display="flex" alignItems="center">
      <Tooltip
        title={
          quote.quote_type === "MULTI_SHIPMENT_PROJECT"
            ? `Project ID: ${shipmentId}`
            : `Shipment ID: ${shipmentId}`
        }
        followCursor
      >
        <Typography variant="h6">{`Shipment ${shipmentId}`}</Typography>
      </Tooltip>
    </Box>
  );
}
